import graphql from './graphql';

const query = /* GraphQL */ `
  query Course_listCoursesByJobTitle($departmentId: String, $jobTitleId: String) {
    Course_listCoursesByJobTitle(departmentId: $departmentId, jobTitleId: $jobTitleId) {
      EnterpriseCourses {
        id
        name
        Enterprise {
          Terminals {
            name
          }
        }
        duration
        CourseCategory {
          name
        }
        CourseType {
          type
        }
      }
      DepartmentCourses {
        id
        name
        Enterprise {
          Terminals {
            name
          }
        }
        duration
        CourseCategory {
          name
        }
        CourseType {
          type
        }
      }
      JobTitleCourses {
        id
        name
        isChecked
        Enterprise {
          Terminals {
            name
          }
        }
        duration
        CourseCategory {
          name
        }
        CourseType {
          type
        }
      }
    }
  }
`;

const CourseListCoursesByJobTitle = async (departmentId, jobTitleId) =>
  graphql(query, { departmentId, jobTitleId }).then(data => data.Course_listCoursesByJobTitle);

export default CourseListCoursesByJobTitle;
